<template>
  <v-sheet height="100%" class="d-flex justify-center align-center flex-column">
    <v-progress-circular
        :bg-color="`#fafafa`" width="10" size="60"
        :color="report_data.special.color"
        :model-value="report_data.percent.toFixed(2)"
    >

      <v-dialog activator="parent" width="30%">
        <v-card class="pa-2" :color="report_data.special.color">
          <template v-slot:title>
            {{ report_data.special.need }} / {{ report_data.special.free }}
          </template>
          <template v-slot:text>
            <p>
              {{ report_data }}
            </p>
          </template>
        </v-card>
      </v-dialog>


      <v-avatar style="font-family: 'Arial Black', sans-serif" variant="outlined" :color="report_data.special.color" class="font-weight-bold">
        {{ report_data.percent.toFixed(0) }}
      </v-avatar>

      <v-tooltip activator="parent" v-if="false">
        <p>
        <span v-if="report_data.special.free">
          Доступно <span class="font-weight-bold">{{ report_data.special.free }}</span> ч/ч
        </span>
          <span v-else>
          Нет свободных специалистов!
        </span>
        </p>
        <p>
        <span v-if="report_data.special.need">
          Необходимо выполнить работ на <span class="font-weight-bold">{{ report_data.special.need }}</span> ч/ч
        </span>
          <span v-else>
          Все работы выполнены
        </span>
        </p>
      </v-tooltip>

    </v-progress-circular>
  </v-sheet>

</template>

<script>
export default {
  name: 'Report__Percent',
  props: ['report_data'],
}
</script>
